export default __webpack_public_path__ + "static/media/GST-CERTIFICATE-INSHA-BANGALES -PVT-LTD.45c2d01d.jpg";